import {gsap} from "gsap";
import {
    ISymbol,
    LonerSymbolStates,
    SYMBOL_NAMES,
    WILD_2X2_SPLIT_NAMES,
    WILD_3X3_SPLIT_NAMES
} from "../../../../core/reel/ReelInterfaces";
import {LonerStatics} from "../../../LonerStatics";
import {Loner} from "../../../Loner";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {LonerWinLineContainer} from "../../../components/LonerWinLineContainer";
import {BLEND_MODES} from "pixi.js";
import {LonerSpine} from "../../../components/LonerSpine";
import {SpineUtils} from "../../../utils/SpineUtils";
import {LonerXWaysPresentation} from "../../../presentationrunners/features/xways/LonerXWaysPresentation";
import {LonerGameMode} from "../../../server/LonerGameMode";

export class LonerSymbol extends PIXI.Container implements ISymbol {

    private _state:LonerSymbolStates;
    protected _reelId:number;
    protected _spineContainer:PIXI.Container;
    protected _darkOverlay:PIXI.Sprite;
    protected _currentStateSprite:PIXI.Sprite;
    protected _newStateSprite:PIXI.Sprite;
    protected _winStateContainer:PIXI.Container;
    protected _winStateAddSprite:PIXI.Sprite;
    protected _winStateNormalSprite:PIXI.Sprite;
    protected _split2SymbolContainer:PIXI.Container;
    protected _split2SymbolSprite:PIXI.Sprite;
    protected _split2SymbolAddSprite:PIXI.Sprite;
    protected _split3SymbolContainer:PIXI.Container;
    protected _split3SymbolSprite:PIXI.Sprite;
    protected _split3SymbolAddSprite:PIXI.Sprite;
    protected _split4SymbolContainer:PIXI.Container;
    protected _split4SymbolSprite:PIXI.Sprite;
    protected _split4SymbolAddSprite:PIXI.Sprite;
    protected _split6SymbolContainer:PIXI.Container;
    protected _split6SymbolSprite:PIXI.Sprite;
    protected _split6SymbolAddSprite:PIXI.Sprite;
    protected _split8SymbolContainer:PIXI.Container;
    protected _split8SymbolSprite:PIXI.Sprite;
    protected _split8SymbolAddSprite:PIXI.Sprite;
    protected _splitLevel:number;
    private _symbolName:string;
    private _originalName:string;
    private _isStacked:boolean;
    protected _reelPosition:number;
    private _reelTargetPosition:number;
    private _isRemoved:boolean;
    private _isUsed:boolean;
    private _isInfected:boolean;
    private _newStateTL:gsap.core.Timeline;
    private _symbolResetTL:gsap.core.Timeline;
    private _randomPositionOffset:PIXI.Point = new PIXI.Point();
    private _originalPosition:PIXI.Point;
    private _infectedSpine:LonerSpine;
    private _featureTextureName:string;
    private _transformedState:LonerSymbolStates;
    private _bigSymbolPart:boolean;

    constructor() {
        super();
        this._bigSymbolPart = false;
        this._isInfected = false;
        this._splitLevel = 1;
        this._isUsed = false;
        this._isStacked = false;
        this._currentStateSprite = new PIXI.Sprite();
        this._currentStateSprite.name = "currentStateSprite";
        this._currentStateSprite.anchor.set(0.5, 0.5);
        this._newStateSprite = new PIXI.Sprite();
        this._newStateSprite.name = "newStateSprite";
        this._newStateSprite.anchor.set(0.5, 0.5);
        this._newStateSprite.alpha = 0;
        this._darkOverlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._darkOverlay.tint = 0x000000;
        this._darkOverlay.alpha = 0;
        this._darkOverlay.anchor.set(0.5, 0.5);
        this._spineContainer = new PIXI.Container();
        this._spineContainer.visible = false;

        this.setDarkOverlaySize();
        this.addChild(this._newStateSprite);
        this.addChild(this._currentStateSprite);
        this.addChild(this._spineContainer);

        this._winStateContainer = new PIXI.Container();
        this._winStateNormalSprite = new PIXI.Sprite();
        this._winStateNormalSprite.anchor.set(0.5, 0.5);
        //Adjusting for shadow
        this._winStateNormalSprite.position.x += 10;
        this._winStateNormalSprite.position.y += 10;
        this._winStateContainer.addChild(this._winStateNormalSprite);
        this._winStateAddSprite = new PIXI.Sprite();
        this._winStateAddSprite.anchor.set(0.5, 0.5);
        this._winStateAddSprite.alpha = 0;
        //Adjusting for shadow
        this._winStateAddSprite.position.x += 10;
        this._winStateAddSprite.position.y += 10;
        this._winStateContainer.addChild(this._winStateAddSprite);
        this._winStateContainer.visible = false;
        this._originalPosition = this.position;

        this._split2SymbolContainer = new PIXI.Container();
        this._split2SymbolContainer.visible = false;
        this._split2SymbolSprite = new PIXI.Sprite();
        this._split2SymbolSprite.anchor.set(0.5, 0.5);
        this._split2SymbolContainer.addChild(this._split2SymbolSprite);
        this._split2SymbolAddSprite = new PIXI.Sprite();
        this._split2SymbolAddSprite.anchor.set(0.5, 0.5);
        this._split2SymbolAddSprite.blendMode = BLEND_MODES.ADD;
        this._split2SymbolContainer.addChild(this._split2SymbolAddSprite);
        Loner.symbolTopView.addChild(this._split2SymbolContainer);

        this._split3SymbolContainer = new PIXI.Container();
        this._split3SymbolContainer.visible = false;
        this._split3SymbolSprite = new PIXI.Sprite();
        this._split3SymbolSprite.anchor.set(0.5, 0.5);
        this._split3SymbolContainer.addChild(this._split3SymbolSprite);
        this._split3SymbolAddSprite = new PIXI.Sprite();
        this._split3SymbolAddSprite.anchor.set(0.5, 0.5);
        this._split3SymbolAddSprite.blendMode = BLEND_MODES.ADD;
        this._split3SymbolContainer.addChild(this._split3SymbolAddSprite);
        Loner.symbolTopView.addChild(this._split3SymbolContainer);

        this._split4SymbolContainer = new PIXI.Container();
        this._split4SymbolContainer.visible = false;
        this._split4SymbolSprite = new PIXI.Sprite();
        this._split4SymbolSprite.anchor.set(0.5, 0.5);
        this._split4SymbolContainer.addChild(this._split4SymbolSprite);
        this._split4SymbolAddSprite = new PIXI.Sprite();
        this._split4SymbolAddSprite.anchor.set(0.5, 0.5);
        this._split4SymbolAddSprite.blendMode = BLEND_MODES.ADD;
        this._split4SymbolContainer.addChild(this._split4SymbolAddSprite);
        Loner.symbolTopView.addChild(this._split4SymbolContainer);

        this._split6SymbolContainer = new PIXI.Container();
        this._split6SymbolContainer.visible = false;
        this._split6SymbolSprite = new PIXI.Sprite();
        this._split6SymbolSprite.anchor.set(0.5, 0.5);
        this._split6SymbolContainer.addChild(this._split6SymbolSprite);
        this._split6SymbolAddSprite = new PIXI.Sprite();
        this._split6SymbolAddSprite.anchor.set(0.5, 0.5);
        this._split6SymbolAddSprite.blendMode = BLEND_MODES.ADD;
        this._split6SymbolContainer.addChild(this._split6SymbolAddSprite);
        Loner.symbolTopView.addChild(this._split6SymbolContainer);

        this._split8SymbolContainer = new PIXI.Container();
        this._split8SymbolContainer.visible = false;
        this._split8SymbolSprite = new PIXI.Sprite();
        this._split8SymbolSprite.anchor.set(0.5, 0.5);
        this._split8SymbolContainer.addChild(this._split8SymbolSprite);
        this._split8SymbolAddSprite = new PIXI.Sprite();
        this._split8SymbolAddSprite.anchor.set(0.5, 0.5);
        this._split8SymbolAddSprite.blendMode = BLEND_MODES.ADD;
        this._split8SymbolContainer.addChild(this._split8SymbolAddSprite);
        Loner.symbolTopView.addChild(this._split8SymbolContainer);
    }

    public init(initState:LonerSymbolStates):LonerSymbol {
        this.getNewStateAnimation(initState);

        return this;
    }

    public getNewStateAnimation(state:LonerSymbolStates, changeSpeed:number = 0.0001, delay:number = 0, newStateAlpha:number = 1):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline({delay : delay});

        if(state == this._state) {
            return tl;
        }

        let newTextureName:string = "";
        switch(state) {
            case LonerSymbolStates.SPLIT2:
                if(this.symbolName == SYMBOL_NAMES.wild2X2) {
                    if(this._reelPosition == 3) {
                        newTextureName = this.symbolName + "/" + WILD_2X2_SPLIT_NAMES.topPosition + this._splitLevel;
                    } else if(this._reelPosition == 6) {
                        newTextureName = this.symbolName + "/" + WILD_2X2_SPLIT_NAMES.bottomPosition + this._splitLevel;
                    } else {
                        newTextureName = this.symbolName + "/" + WILD_2X2_SPLIT_NAMES.fullPosition + this._splitLevel;
                    }
                } else if(this.symbolName == SYMBOL_NAMES.wild3X3) {
                    if(this._reelPosition == 3) {
                        newTextureName = this.symbolName + "/" + WILD_3X3_SPLIT_NAMES.topPosition + this._splitLevel;
                    } else if(this._reelPosition == 4) {
                        newTextureName = this.symbolName + "/" + WILD_3X3_SPLIT_NAMES.halfTopPosition + this._splitLevel;
                    } else if(this._reelPosition == 5) {
                        newTextureName = this.symbolName + "/" + WILD_3X3_SPLIT_NAMES.fullPosition + this._splitLevel;
                    } else if(this._reelPosition == 6) {
                        newTextureName = this.symbolName + "/" + WILD_3X3_SPLIT_NAMES.halfBottomPosition + this._splitLevel;
                    } else {
                        newTextureName = this.symbolName + "/" + WILD_3X3_SPLIT_NAMES.bottomPosition + this._splitLevel;
                    }
                } else {
                    newTextureName = this.symbolName + "/" + this.symbolName + "_Split_" + this._splitLevel;
                }
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case LonerSymbolStates.SPLIT4:
                if(this.symbolName == SYMBOL_NAMES.wild2X2) {
                    if(this._reelPosition == 3) {
                        newTextureName = this.symbolName + "/" + WILD_2X2_SPLIT_NAMES.topPosition + this._splitLevel;
                    } else if(this._reelPosition == 6) {
                        newTextureName = this.symbolName + "/" + WILD_2X2_SPLIT_NAMES.bottomPosition + this._splitLevel;
                    } else {
                        newTextureName = this.symbolName + "/" + WILD_2X2_SPLIT_NAMES.fullPosition + this._splitLevel;
                    }
                } else if(this.symbolName == SYMBOL_NAMES.wild3X3) {
                    if(this._reelPosition == 3) {
                        newTextureName = this.symbolName + "/" + WILD_3X3_SPLIT_NAMES.topPosition + this._splitLevel;
                    } else if(this._reelPosition == 4) {
                        newTextureName = this.symbolName + "/" + WILD_3X3_SPLIT_NAMES.halfTopPosition + this._splitLevel;
                    } else if(this._reelPosition == 5) {
                        newTextureName = this.symbolName + "/" + WILD_3X3_SPLIT_NAMES.fullPosition + this._splitLevel;
                    } else if(this._reelPosition == 6) {
                        newTextureName = this.symbolName + "/" + WILD_3X3_SPLIT_NAMES.halfBottomPosition + this._splitLevel;
                    } else {
                        newTextureName = this.symbolName + "/" + WILD_3X3_SPLIT_NAMES.bottomPosition + this._splitLevel;
                    }
                } else {
                    newTextureName = this.symbolName + "/" + this.symbolName + "_Split_" + this._splitLevel;
                }
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case LonerSymbolStates.SPLIT3:
                newTextureName = this.symbolName + "/" + this.symbolName + "_Split_" + this._splitLevel;
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case LonerSymbolStates.SPLIT6:
                newTextureName = this.symbolName + "/" + this.symbolName + "_Split_" + this._splitLevel;
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case LonerSymbolStates.SPLIT8:
                newTextureName = this.symbolName + "/" + this.symbolName + "_Split_" + this._splitLevel;
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case LonerSymbolStates.SCATTER_TRANSFORMED:
                newTextureName = "S/" + this.featureTextureName;
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case LonerSymbolStates.SCATTER_INFECTED:
                newTextureName = this.featureTextureName;
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case LonerSymbolStates.NORMAL:
                newTextureName = this.symbolName + "/" + this.symbolName;
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case LonerSymbolStates.NORMAL_FEATURE:
                newTextureName = "S" + "/" + this.featureTextureName;
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case LonerSymbolStates.SPIN_IN:
                newTextureName = this.symbolName + "/" + this.symbolName + "_spin";
                if((this._symbolName !== SYMBOL_NAMES.wild2X2) && (this._symbolName !== SYMBOL_NAMES.wild3X3)) {
                    this._randomPositionOffset = new PIXI.Point(1 - (MathHelper.randomIntInRange(0, 2)), 1 - (MathHelper.randomIntInRange(0, 2)));
                    this.position.x += this._randomPositionOffset.x;
                    this.position.y += this._randomPositionOffset.y;
                }
                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case LonerSymbolStates.SPIN_OUT:
                if(this._isInfected == true && this._infectedSpine) {
                    this._infectedSpine.visible = false;
                    this._infectedSpine.isUsed = false;
                }
                if(this._state == LonerSymbolStates.SCATTER_TRANSFORMED) {
                    newTextureName = "S/" + this.featureTextureName + "_spin";
                } else if(this._state == LonerSymbolStates.SCATTER_INFECTED) {
                    newTextureName = this.featureTextureName + "_spin";
                } else if(this._splitLevel == 2) {
                    newTextureName = this.symbolName + "/" + this.symbolName + "_Split_2_spin";
                } else if(this._splitLevel == 4) {
                    newTextureName = this.symbolName + "/" + this.symbolName + "_Split_4_spin";
                } else {
                    newTextureName = this.symbolName + "/" + this.symbolName + "_spin";
                }

                tl.add(this.setState(state, newTextureName, changeSpeed, newStateAlpha));
                break;
            case LonerSymbolStates.NO_WIN:
                if(this.symbolName == SYMBOL_NAMES.S &&
                    (Loner.model.scatterTransform[this._reelId] == LonerSymbolStates.SCATTER_MAX_WIN
                        || Loner.model.scatterTransform[this._reelId] == LonerSymbolStates.M
                        || Loner.model.scatterTransform[this._reelId] == LonerSymbolStates.A
                        || Loner.model.scatterTransform[this._reelId] == LonerSymbolStates.X)
                ) {
                    //Don't set MAX WIN syms to no win
                } else if(this.symbolName == SYMBOL_NAMES.S && (Loner.model.nextMode == LonerGameMode.FEATURE_PIN_THE_WIN
                    || Loner.model.nextMode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK
                    || Loner.model.nextMode == LonerGameMode.FEATURE_TICK_TICK_BOOM)) {
                    //Don't set Feature Win scatters to no win
                } else {
                    tl.add(gsap.to(this._darkOverlay, {duration : changeSpeed, alpha : 0.6}));
                }
                break;
            case LonerSymbolStates.TOGGLE_WIN:
                tl.add(() => {
                    this._winStateContainer.alpha = 0;
                    this._winStateContainer.visible = true;
                });
                tl.add([
                    gsap.to(this._winStateContainer, {duration : changeSpeed, alpha : 1}),
                    gsap.to(this._darkOverlay, {duration : changeSpeed, alpha : 0})
                ]);
                tl.add(() => {
                    this._state = state
                });
                break;
            case LonerSymbolStates.TOGGLE_NORMAL:
                tl.add(() => {
                    this._winStateContainer.alpha = 1;
                });
                tl.add([
                    gsap.to(this._winStateContainer, {duration : changeSpeed, alpha : 0}),
                    gsap.to(this._darkOverlay, {duration : changeSpeed, alpha : 0.2})
                ]);
                tl.add(() => {
                    this._winStateContainer.visible = false;
                });
                tl.add(() => {
                    this._state = state
                });
                break;
            default:
        }

        return tl;
    }

    protected setState(state:LonerSymbolStates, textureName:string, changeSpeed:number = 0, newStateAlpha:number = 1):gsap.core.Timeline {
        if(this._newStateTL && this._newStateTL.isActive()) {
            this._newStateTL.pause();
            this._newStateTL.kill();
        }
        this._newStateTL = gsap.timeline();
        this._newStateTL.add(() => {
            this._state = state;
            this._newStateSprite.texture = Loner.assetLoader.getTextures(textureName)[0];
        });
        this._newStateTL.add([
            gsap.to(this._currentStateSprite, {
                duration : changeSpeed,
                alpha : 0,
                ease : "power2.in"
            }),
            gsap.to(this._newStateSprite, {
                duration : changeSpeed,
                alpha : newStateAlpha,
                ease : "power2.out"
            })
        ]);
        this._newStateTL.add(() => {
            this._currentStateSprite.texture = this._newStateSprite.texture;
            this._currentStateSprite.alpha = 1;
            this._newStateSprite.alpha = 0;
        });

        return this._newStateTL;
    }

    public getShowInfectiousSplatTL():gsap.core.Timeline {
        let newSplitValue:number = Loner.model.symbolSizes[this._reelId][this._reelPosition - 3];
        if(Loner.model.xSplitInfo.length > 0) {
            //If a Split on same row we should only do half value now
            if(Loner.model.xSplitInfo[0].pos[1] == (this.reelPosition - 3)) {
                newSplitValue /= 2;
            }
        }
        this._splitLevel = newSplitValue;

        const infectSymbolTL:gsap.core.Timeline = gsap.timeline();
        infectSymbolTL.add(() => {
            this.isInfected = true;
            this._infectedSpine = Loner.infectedSymbolSpinePool.getInfectedSymbolSpine();
            this._infectedSpine.position.x = LonerStatics.reelPositions[this._reelId].x;
            this._infectedSpine.position.y = LonerStatics.symbolHeight * (this._reelPosition - 1);
            this._infectedSpine.visible = true;
            SpineUtils.resetSpineAnimation(this._infectedSpine);
        });

        infectSymbolTL.add(() => {
            this._infectedSpine.state.setAnimation(0, LonerXWaysPresentation.getInfectedAnimationName(), false);
        });
        infectSymbolTL.add(this.getSplitSymbolTL(newSplitValue), "+=0.5");

        return infectSymbolTL;
    }

    protected setSplitContainerBasePosition():PIXI.Point {
        return new PIXI.Point((this._reelId * LonerStatics.symbolWidth), ((this._reelPosition - 1) * LonerStatics.symbolHeight));
    }

    protected getSplitSymbolStartTexture():PIXI.Texture {
        if(this._splitLevel == 2) {
            return Loner.assetLoader.getTextures(this.symbolName + "/" + this.symbolName)[0];
        } else {
            return Loner.assetLoader.getTextures(this.symbolName + "/" + this.symbolName + "_Split_" + this._splitLevel)[0];
        }
    }

    protected getSplitSymbolSplitTexture():PIXI.Texture {
        return Loner.assetLoader.getTextures(this.symbolName + "/" + this.symbolName + "_Split_" + this._splitLevel)[0];
    }

    public getSplitSymbolTL(newSplitLevel:number = this.splitLevel *= 2):gsap.core.Timeline {
        const splitTL:gsap.core.Timeline = gsap.timeline();
        if(this._symbolName == "S" || this.bigSymbolPart == true) {
            this.splitLevel = 1;
            return splitTL;
        }
        this._splitLevel = newSplitLevel;
        if(this._splitLevel == 2) {
            splitTL.add(() => {
                this._split2SymbolContainer.alpha = 0;
                this._split2SymbolContainer.visible = true;
                this._split2SymbolSprite.texture = this.getSplitSymbolStartTexture();
                this._split2SymbolAddSprite.texture = this._split2SymbolSprite.texture;
            });
            splitTL.add(() => {
                this._split2SymbolContainer.position = this.setSplitContainerBasePosition();
                this._split2SymbolContainer.scale.set(1.08, 1.08);
                this._split2SymbolContainer.alpha = 1;
            });
        } else if(this._splitLevel == 3) {
            splitTL.add(() => {
                this._split3SymbolContainer.alpha = 0;
                this._split3SymbolContainer.visible = true;
                this._split3SymbolSprite.texture = this.getSplitSymbolStartTexture();
                this._split3SymbolAddSprite.texture = this._split3SymbolSprite.texture;
            });
            splitTL.add(() => {
                this._split3SymbolContainer.position = this.setSplitContainerBasePosition();
                this._split3SymbolContainer.scale.set(1.08, 1.08);
                this._split3SymbolContainer.alpha = 1;
            });
        } else if(this._splitLevel == 4) {
            splitTL.add(() => {
                this._split4SymbolContainer.alpha = 0;
                this._split4SymbolContainer.visible = true;
                this._split4SymbolSprite.texture = this.getSplitSymbolStartTexture();
                this._split4SymbolAddSprite.texture = this._split4SymbolSprite.texture;
            });
            splitTL.add(() => {
                this._split4SymbolContainer.position = this.setSplitContainerBasePosition();
                this._split4SymbolContainer.scale.set(1.08, 1.08);
                this._split4SymbolContainer.alpha = 1;
            });
        } else if(this._splitLevel == 6) {
            splitTL.add(() => {
                this._split6SymbolContainer.alpha = 0;
                this._split6SymbolContainer.visible = true;
                this._split6SymbolSprite.texture = this.getSplitSymbolStartTexture();
                this._split6SymbolAddSprite.texture = this._split6SymbolSprite.texture;
            });
            splitTL.add(() => {
                this._split6SymbolContainer.position = this.setSplitContainerBasePosition();
                this._split6SymbolContainer.scale.set(1.08, 1.08);
                this._split6SymbolContainer.alpha = 1;
            });
        } else if(this._splitLevel == 8) {
            splitTL.add(() => {
                this._split8SymbolContainer.alpha = 0;
                this._split8SymbolContainer.visible = true;
                this._split8SymbolSprite.texture = this.getSplitSymbolStartTexture();
                this._split8SymbolAddSprite.texture = this._split6SymbolSprite.texture;
            });
            splitTL.add(() => {
                this._split8SymbolContainer.position = this.setSplitContainerBasePosition();
                this._split8SymbolContainer.scale.set(1.08, 1.08);
                this._split8SymbolContainer.alpha = 1;
            });
        }

        if(this._splitLevel == 2) {
            splitTL.add(this.getNewStateAnimation(LonerSymbolStates.SPLIT2));
        } else if(this._splitLevel == 3) {
            splitTL.add(this.getNewStateAnimation(LonerSymbolStates.SPLIT3));
        } else if(this._splitLevel == 4) {
            splitTL.add(this.getNewStateAnimation(LonerSymbolStates.SPLIT4));
        } else if(this._splitLevel == 6) {
            splitTL.add(this.getNewStateAnimation(LonerSymbolStates.SPLIT6));
        } else if(this._splitLevel == 8) {
            splitTL.add(this.getNewStateAnimation(LonerSymbolStates.SPLIT8));
        }

        if(this._splitLevel == 2) {
            splitTL.add(() => {
                this._split2SymbolSprite.texture = this.getSplitSymbolSplitTexture();
                this._split2SymbolAddSprite.texture = this.getSplitSymbolSplitTexture();
            })
            splitTL.add([
                gsap.to(this._split2SymbolContainer.scale, {duration : 0.16, x : 1, y : 1}),
                gsap.to(this._split2SymbolAddSprite, {duration : 0.33, alpha : 0}),
                gsap.to(this._split2SymbolSprite, {duration : 0.33, alpha : 0})
            ]);
            splitTL.add(() => {
                this._split2SymbolContainer.visible = false;
                this._split2SymbolSprite.alpha = 1;
                this._split2SymbolAddSprite.alpha = 1;
            })
        } else if(this._splitLevel == 3) {
            splitTL.add(() => {
                this._split3SymbolSprite.texture = this.getSplitSymbolSplitTexture();
                this._split3SymbolAddSprite.texture = this.getSplitSymbolSplitTexture();
            })
            splitTL.add([
                gsap.to(this._split3SymbolContainer.scale, {duration : 0.16, x : 1, y : 1}),
                gsap.to(this._split3SymbolAddSprite, {duration : 0.33, alpha : 0}),
                gsap.to(this._split3SymbolSprite, {duration : 0.33, alpha : 0})
            ]);
            splitTL.add(() => {
                this._split3SymbolContainer.visible = false;
                this._split3SymbolSprite.alpha = 1;
                this._split3SymbolAddSprite.alpha = 1;
            })
        } else if(this._splitLevel == 4) {
            splitTL.add(() => {
                this._split4SymbolSprite.texture = this.getSplitSymbolSplitTexture();
                this._split4SymbolAddSprite.texture = this.getSplitSymbolSplitTexture();
            })
            splitTL.add([
                gsap.to(this._split4SymbolContainer.scale, {duration : 0.16, x : 1, y : 1}),
                gsap.to(this._split4SymbolAddSprite, {duration : 0.33, alpha : 0}),
                gsap.to(this._split4SymbolSprite, {duration : 0.33, alpha : 0})
            ]);
            splitTL.add(() => {
                this._split4SymbolContainer.visible = false;
                this._split4SymbolSprite.alpha = 1;
                this._split4SymbolAddSprite.alpha = 1;
            })
        } else if(this._splitLevel == 6) {
            splitTL.add(() => {
                this._split6SymbolSprite.texture = this.getSplitSymbolSplitTexture();
                this._split6SymbolAddSprite.texture = this.getSplitSymbolSplitTexture();
            })
            splitTL.add([
                gsap.to(this._split6SymbolContainer.scale, {duration : 0.16, x : 1, y : 1}),
                gsap.to(this._split6SymbolAddSprite, {duration : 0.33, alpha : 0}),
                gsap.to(this._split6SymbolSprite, {duration : 0.33, alpha : 0})
            ]);
            splitTL.add(() => {
                this._split6SymbolContainer.visible = false;
                this._split6SymbolSprite.alpha = 1;
                this._split6SymbolAddSprite.alpha = 1;
            })
        } else if(this._splitLevel == 8) {
            splitTL.add(() => {
                this._split8SymbolSprite.texture = this.getSplitSymbolSplitTexture();
                this._split8SymbolAddSprite.texture = this.getSplitSymbolSplitTexture();
            })
            splitTL.add([
                gsap.to(this._split8SymbolContainer.scale, {duration : 0.16, x : 1, y : 1}),
                gsap.to(this._split8SymbolAddSprite, {duration : 0.33, alpha : 0}),
                gsap.to(this._split8SymbolSprite, {duration : 0.33, alpha : 0})
            ]);
            splitTL.add(() => {
                this._split8SymbolContainer.visible = false;
                this._split8SymbolSprite.alpha = 1;
                this._split8SymbolAddSprite.alpha = 1;
            })
        }

        return splitTL;
    }

    //Called from initial/individual pres
    public makeReadyForSpin():void {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(this.fadeOutDarkOverlay());
        tl.add(() => {
            this._winStateContainer.visible = true;
        });
        tl.add([
            gsap.to(this._spineContainer, {delay : 0.15, duration : 0.15, alpha : 0}),
            gsap.to(this._winStateContainer, {duration : 0.1, alpha : 0}),
        ]);
        tl.add(() => {
            this._spineContainer.visible = false;
            this._spineContainer.alpha = 1;
        })
    }

    public fadeOutDarkOverlay():gsap.core.Tween {
        let duration:number = 0.2;
        if(this._darkOverlay.alpha == 0) {
            duration = 0;
        }
        return gsap.to(this._darkOverlay, {duration : duration, alpha : 0});
    }

    protected setWinTextures():void {
        if(this.symbolName !== "S") {
            if(this._splitLevel == 1) {
                this._winStateNormalSprite.texture = Loner.assetLoader.getTextures(this.symbolName + "/" + this.symbolName + "_win")[0];
                this._winStateAddSprite.texture = Loner.assetLoader.getTextures(this.symbolName + "/" + this.symbolName + "_win_add")[0];
            } else {
                this._winStateNormalSprite.texture = Loner.assetLoader.getTextures(this.symbolName + "/" + this.symbolName + "_Split_" + this._splitLevel + "_win")[0];
                this._winStateAddSprite.texture = Loner.assetLoader.getTextures(this.symbolName + "/" + this.symbolName + "_Split_" + this._splitLevel + "_win_add")[0];
            }
        }
    }

    protected setWinContainerPosition():void {
    }

    public getInitialWinAnimation(winContainer:LonerWinLineContainer):gsap.core.Timeline {
        let scaleStep:number = 1.2;
        let scaleEnd:number = 1.4;
        if(this.symbolName == SYMBOL_NAMES.wild2X2) {
            scaleStep = 1.05;
            scaleEnd = 1.1;
        }
        if(this.symbolName == SYMBOL_NAMES.wild3X3) {
            scaleStep = 1.25;
            scaleEnd = 1.05;
        }
        this.setWinTextures();

        //Match reel area position
        this._winStateContainer.position = LonerStatics.reelPositions[this._reelId];
        this._winStateContainer.position.y = LonerStatics.symbolHeight * (this.reelPosition - 2);
        this.setWinContainerPosition();
        this._winStateContainer.position.x += this._randomPositionOffset.x;
        this._winStateContainer.position.y += this._randomPositionOffset.y;
        const winTL:gsap.core.Timeline = gsap.timeline();
        //Delay for no win to darken down
        winTL.add(gsap.timeline({delay : 0.2}));
        winTL.add(() => {
            this._winStateAddSprite.alpha = 0;
            this._winStateContainer.visible = true;
            winContainer.mainContainer.alpha = 1;
            winContainer.mainContainer.addChild(this._winStateContainer);
            winContainer.pinAndThreadContainer.alpha = 1;
        });
        //winTL.add(gsap.timeline({delay:0.06}));

        winTL.add([
            gsap.to(this._winStateAddSprite, {duration : 0.001, alpha : 1})
        ]);
        winTL.add([
            gsap.to(this._winStateAddSprite, {duration : 0.1, alpha : 0})
        ]);
        winTL.add([
            gsap.to(this._winStateContainer.scale, {duration : 0.001, x : scaleStep, y : scaleStep}),
            gsap.to(this._winStateContainer, {duration : 0.001, angle : 0 + (2 - MathHelper.randomIntInRange(0, 4))}),
            gsap.to(this._winStateAddSprite, {duration : 0.001, alpha : 1})
        ]);
        winTL.add(gsap.timeline({delay : 0.03}));
        winTL.add([
            gsap.to(this._winStateContainer.scale, {duration : 0.001, x : scaleEnd, y : scaleEnd}),
            gsap.to(this._winStateContainer, {duration : 0.001, angle : 0 + (2 - MathHelper.randomIntInRange(0, 4))})
        ]);
        //Fade out to normal look and do a small shake
        winTL.add(() => {
            gsap.to(this._winStateAddSprite, {duration : 0.1, alpha : 0})
        });
        winTL.add(gsap.to(this._winStateContainer.position, {
            duration : 0.001,
            x : this._winStateContainer.position.x += (1 - (MathHelper.randomIntInRange(0, 4))),
            y : this._winStateContainer.position.y += (1 - (MathHelper.randomIntInRange(0, 4)))
        }));
        winTL.add(gsap.timeline({delay : 0.03}));
        winTL.add(gsap.to(this._winStateContainer.position, {
            duration : 0.001,
            x : this._winStateContainer.position.x += (1 - (MathHelper.randomIntInRange(0, 4))),
            y : this._winStateContainer.position.y += (1 - (MathHelper.randomIntInRange(0, 4)))
        }));
        winTL.add(() => {
            this.state = LonerSymbolStates.TOGGLE_WIN
        });

        return winTL;
    }

    protected setDarkOverlaySize(width:number = LonerStatics.symbolWidth, height:number = LonerStatics.symbolHeight):void {
        this._darkOverlay.width = width;
        this._darkOverlay.height = height;
    }

    public reset():void {
        this.addChild(this._darkOverlay);
        this._bigSymbolPart = false;
        this._splitLevel = 1;
        this._isInfected = false;
        this._darkOverlay.alpha = 0;
        this._currentStateSprite.position.y = 0;
        this._newStateSprite.position.y = 0;
        this._currentStateSprite.alpha = 1;
        this._newStateSprite.alpha = 0;
        this.position.x = 0;
        this.position.y = 0;
        this.visible = true;
        this._winStateContainer.visible = false;
        this._winStateContainer.alpha = 1;
        //Making sure state is correct before it can be re-used
        if (this._symbolResetTL){
            this._symbolResetTL.kill();
        }
        this._symbolResetTL = gsap.timeline({
            onComplete : () => {
                this._isUsed = false;
            }
        }).add((<LonerSymbol>this).getNewStateAnimation(LonerSymbolStates.SPIN_OUT));
    }

    get state():LonerSymbolStates {
        return this._state;
    }

    set state(value:LonerSymbolStates) {
        this._state = value;
    }

    get reelPosition():number {
        return this._reelPosition;
    }

    set reelPosition(value:number) {
        this._reelPosition = value;
    }

    get reelId():number {
        return this._reelId;
    }

    set reelId(value:number) {
        this._reelId = value;
    }

    get isRemoved():boolean {
        return this._isRemoved;
    }

    get stackedSymbolName():string {
        return this._originalName;
    }

    set stackedSymbolName(value:string) {
        this._originalName = value;
    }

    get symbolName():string {
        return this._symbolName;
    }

    set symbolName(value:string) {
        this._symbolName = value;
    }

    get isUsed():boolean {
        return this._isUsed;
    }

    set isUsed(value:boolean) {
        this._isUsed = value;
    }

    get darkOverlay():PIXI.Sprite {
        return this._darkOverlay;
    }

    get isStacked():boolean {
        return this._isStacked;
    }

    set isStacked(value:boolean) {
        this._isStacked = value;
    }

    set isInfected(value:boolean) {
        this._isInfected = value;
    }

    get isInfected():boolean {
        return this._isInfected;
    }

    get featureTextureName():string {
        return this._featureTextureName;
    }

    set featureTextureName(value:string) {
        this._featureTextureName = value;
    }

    get transformedState():LonerSymbolStates {
        return this._transformedState;
    }

    set transformedState(value:LonerSymbolStates) {
        this._transformedState = value;
    }

    get bigSymbolPart():boolean {
        return this._bigSymbolPart;
    }

    set bigSymbolPart(value:boolean) {
        this._bigSymbolPart = value;
    }

    get splitLevel():number {
        return this._splitLevel;
    }

    set splitLevel(value:number) {
        this._splitLevel = value;
    }
}